import React, { PureComponent } from 'react';
import { Translate, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import {
  firebaseConnect,
  getVal,
  isLoaded,
  populate
} from 'react-redux-firebase';
import dayjs from 'dayjs';
import { compose } from 'redux';
import styled from 'styled-components';

import Booking from '../../components/booking';
import Indicator from '../../components/indicator';
import TitledSection from '../../components/titled-section';
import withDatabase from '../../hocs/with-database';
import jaLocale from './ja.locale';

const CentredText = styled.div`
  text-align: center;
`;

/**
 * Show played games and answers
 */
class History extends PureComponent {
  state = {
    openBooking: null
  };
  constructor(props) {
    super(props);
    this.props.addTranslationForLanguage(jaLocale, 'ja');
  }
  renderBookings() {
    const loaded =
      isLoaded(this.props.games) &&
      this.props.bookings &&
      this.props.bookings.filter(booking => booking === undefined).length === 0;
    if (!loaded) {
      return <Indicator spin />;
    }
    const bookings = this.getBookings();
    if (!bookings || !bookings.length) {
      return (
        <CentredText>
          <Translate id="history.none" />
        </CentredText>
      );
    }
    return bookings.map(([key, value]) => (
      <Booking
        bookingId={key}
        game={this.props.games[value.gameId]}
        key={key}
        locale={this.props.activeLanguage.code}
        open={this.state.openBooking === key}
        {...value}
        onClick={this.handleOpenToggle}
      />
    ));
  }

  handleOpenToggle = bookingId => {
    if (this.state.openBooking === bookingId) {
      this.setState({
        openBooking: null
      });
      return;
    }
    this.setState({
      openBooking: bookingId
    });
  };

  getBookings() {
    const { bookings } = this.props;
    if (!bookings || !bookings.length) {
      return [];
    }
    const endOfDay = dayjs()
      .endOf('day')
      .unix();
    return bookings
      .reduce((flattened, gameBookings = {}) => {
        flattened.push(...Object.entries(gameBookings || {}));
        return flattened;
      }, [])
      .filter(
        ([, booking]) =>
          booking && booking.timeslot && booking.timeslot.time < endOfDay
      )
      .sort(
        ([, bookinga], [, bookingb]) =>
          bookingb.timeslot.time - bookinga.timeslot.time
      );
  }

  /**
   * @inheritDoc
   */
  render() {
    return (
      <TitledSection subtitleId="history.subtitle" titleId="history.title">
        {this.renderBookings()}
      </TitledSection>
    );
  }
}

/**
 * Map Redux State to props
 //  */
const mapStateToProps = ({ firebase, auth, global }) => {
  /**
   * Firebase auth uid
   */
  const games = getVal(firebase.data, '/games');
  const bookings =
    games &&
    games.length &&
    games.map((game, index) => {
      return populate(firebase, `bookings/${index}`, [
        {
          child: 'timeslotId',
          childAlias: 'timeslot',
          root: `timeslots/${index}/`
        }
      ]);
    });
  return {
    userEmail: auth.user.email,
    gameId: global.gameId,
    games: getVal(firebase.data, '/games'),
    bookings
  };
};

export default compose(
  withDatabase,
  withLocalize,
  connect(mapStateToProps, null),
  firebaseConnect(({ games, userEmail }) => {
    const paths = ['/games'];
    if (games && games.length) {
      paths.push(
        ...games.map((games, index) => {
          return {
            path: `bookings/${index}`,
            queryParams: ['orderByChild=userEmail', `equalTo=${userEmail}`],
            populates: [{ child: 'timeslotId', root: `timeslots/${index}/` }]
          };
        })
      );
    }
    return paths;
  })
)(History);
